import {
  Autocomplete,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import Pagination from 'base/ui/components/Pagination/pagination';
import { observer } from 'mobx-react';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiSearch } from 'react-icons/hi';
import { MdClose } from 'react-icons/md';
import { TbUpload } from 'react-icons/tb';
import { toast } from 'react-toastify';
import { CategoryModel } from 'services/listCategory_services';
import * as rootStore from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';

export function createProductRouting() {
  return observer(() => {
    const column = [
      {
        columnName: 'STT',
        align: 'text-center',
        visible: true,
        sticky: 'sticky left-0 bg-primary z-10',
      },
      {
        columnName: 'Phiên bản Routing',
        align: 'text-center',
        visible: true,
        sticky: 'sticky left-[120px] bg-primary z-10',
      },

      {
        columnName: 'Mã TP/BTP',
        align: 'text-center',
        visible: true,
        sticky: 'sticky left-[240px]  bg-primary z-10',
      },

      {
        columnName: 'Tên TP/BTP',
        align: 'text-center',
        visible: true,
        sticky: 'sticky left-[360px] bg-primary z-10 shadow-xl',
      },

      { columnName: 'Thứ tự công đoạn', align: 'text-center', visible: true },

      { columnName: 'Mã công đoạn', align: 'text-center', visible: true },
      {
        columnName: 'Tên công đoạn',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Hướng dẫn sản xuất',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: '% Ước tính hoàn thành',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Thời gian định mức (min)',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Khuôn',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Số SP/ Tờ/ Công đoạn',
        align: 'text-center',
        visible: true,
      },
    ];
    const Style = {
      MuiTableCellRoot: {
        fontSize: '13px',
        fontWeight: 700,
        padding: '5px',
        lineHeight: '20px',
        color: 'white',
      },
      borderInherit: {
        borderCollapse: 'inherit',
      },
      MuiTableCellRootTd: {
        fontSize: '13px',
        padding: '5px',
        lineHeight: '20px',
        borderBottom: 'unset',
      },
      sticky1: {
        position: 'sticky',
        left: 0,
        background: 'white',
        zIndex: 5,
      },
      sticky2: {
        position: 'sticky',
        left: 120,
        background: 'white',
        zIndex: 5,
      },
      sticky3: {
        position: 'sticky',
        left: 240,
        background: 'white',
        zIndex: 5,
      },
      sticky4: {
        position: 'sticky',
        left: 360,
        background: 'white',
        zIndex: 5,
      },
      hoverColor: {
        background: 'rgb(0 166 90 / 1)',
        color: 'white',
      },
      '.MuiOutlinedInput-root': {
        padding: 0,
        borderRadius: 0,
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input[aria-controls]': {
        fontSize: '13px',
      },
      '.MuiFormControl-root': {
        with: '500px',
        maxWidth: '500px',
      },
      '.MuiButtonBase-root': {
        height: '24px',
      },
      '.MuiSvgIcon-root': {
        fontSize: '16px',
      },
      '.MuiAutocomplete-endAdornment': {
        top: 'unset',
      },
    };

    // ==========================STATE=======================
    // số lượng items trên 1 trang
    const [pageSize, setPageSize] = useState(PAGE_SIZE_DEFAULT);
    // current page
    const [pageIndex, setPageIndex] = useState(1);
    const [open, setOpen] = useState(false);
    // import file excel to api
    const [fileExcel, setFileExcel] = useState<File>();
    // set word search from ProductCode input
    const [keyword, setKeyword] = useState<string>('');
    const [listProductCode, setListProductCode] = useState<CategoryModel[]>([]);
    const [listProductCodeId, setListProductCodeId] = useState<(string | null)[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    // ==========================FUNCTION====================

    const { handleSubmit } = useForm();

    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setPageSize(parseInt(e.target.value));
    };

    // handle page index when page index change
    const handleChangePageIndex = (data: any) => {
      setPageIndex(data.selected + 1);
    };

    // handle close modal
    const handleCloseModal = () => {
      setFileExcel(undefined);
      setOpen(false);
    };

    // get array from autocomplete
    const handleChangeProductCode = (e: SyntheticEvent<Element, Event>, items: CategoryModel[]) => {
      if (items) {
        const listItem = items.map((item) => {
          return item.key;
        });
        if (listItem) {
          setListProductCodeId(listItem);
        }
      }
    };

    const handleChangeKeyWord = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setKeyword(e.target.value);
      await rootStore.productRoutingPresenter.getListProductCode(rootStore.productRoutingStore, e.target.value);
      setListProductCode(rootStore.productRoutingStore.listProductCodeResponse.data);
    };

    const onSearch = async () => {
      await rootStore.productRoutingPresenter.getListProductRouting(rootStore.productRoutingStore, {
        paging: {
          pageIndex: 1,
          pageSize: pageSize,
        },
        productCode: listProductCodeId,
      });
    };

    // handle set value file
    const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = e.target.files;

      if (!files) {
        return;
      }
      setFileExcel(files[0]);
    };

    // import file to api product routing
    const ImportExcelProductRouting = async () => {
      const formData = new FormData();
      if (fileExcel) {
        formData.append('FileImport', fileExcel);
        await rootStore.productRoutingPresenter.importExcelProductRounting(rootStore.productRoutingStore, formData);
        const result = rootStore.productRoutingStore.importExcelResponse;
        if (result.isSuccess) {
          toast.success(result.message);
          setFileExcel(undefined);
          setOpen(false);
        } else {
          toast.error(result.message);
        }
      }
    };

    useEffect(() => {
      setIsLoading(true);
      const getListProductRouting = async () => {
        await rootStore.productRoutingPresenter.getListProductRouting(rootStore.productRoutingStore, {
          paging: {
            pageIndex: pageIndex,
            pageSize: pageSize,
          },
          productCode: listProductCodeId,
        });
        setIsLoading(false);
      };
      const getListProductCode = async () => {
        await rootStore.productRoutingPresenter.getListProductCode(rootStore.productRoutingStore, keyword);
        setListProductCode(rootStore.productRoutingStore.listProductCodeResponse.data);
      };
      getListProductCode();

      getListProductRouting();
    }, [pageIndex]);

    useEffect(() => {
      setIsLoading(true);
      const getListProductRouting = async () => {
        await rootStore.productRoutingPresenter.getListProductRouting(rootStore.productRoutingStore, {
          paging: {
            pageIndex: 1,
            pageSize: pageSize,
          },
          productCode: listProductCodeId,
        });
        setIsLoading(false);
      };
      getListProductRouting();
    }, [pageSize]);

    // các row trong table lấy từ store
    const tableRows = rootStore.productRoutingStore.productRouting.data;
    return (
      <div className="w-full py-3 px-5">
        {isLoading && <LoadingScreen />}
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-md font-bold text-gray-800 uppercase">Công đoạn sản xuất</h3>
          <button
            onClick={() => {
              setOpen(true);
            }}
            type="submit"
            className={`flex items-center justify-center bg-success text-white  rounded text-sm px-2.5 pt-[0.25rem] pb-[0.3rem] text-center focus:outline-none hover:bg-success_hover `}
          >
            <TbUpload className="mr-2 text-white text-base" />
            <span>Import</span>
          </button>
        </div>

        <div className="w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300">
          <form className="w-full flex flex-col">
            {/* Mã TP/BTP*/}
            <div className="w-full md:flex-row md:items-center flex flex-col md:grid md:grid-cols-6">
              <label className="min-w-[150px] font-medium text-sm text-gray-700 md:text-center text-left ">
                Mã TP/BTP
              </label>

              <Autocomplete
                multiple
                className="md:col-span-4 text-sm focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                limitTags={2}
                id="multiple-limit-tags"
                options={listProductCode}
                classes={{ listbox: 'text-default' }}
                filterOptions={(options, state) => options}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField onChange={handleChangeKeyWord} {...params} />}
                sx={Style}
                onChange={handleChangeProductCode}
              />
            </div>

            {/* button tìm kiếm */}
            <div className="w-full flex justify-center col-span-2 mt-3.5">
              <button
                type="submit"
                onClick={handleSubmit(onSearch)}
                className={`flex items-center text-white bg-blue-700 rounded text-sm px-2.5 py-1 text-center focus:outline-none hover:bg-blue-600`}
              >
                <>
                  <HiSearch className="font-bold text-xl" />
                  Tìm kiếm
                </>
              </button>
            </div>
          </form>
        </div>
        {/* Table product */}
        <div className="w-full bg-white p-3.5 rounded border border-neutral-300">
          {/*=========== Pagination =======================*/}
          <Pagination
            pageCount={rootStore.productRoutingStore.productRouting.pagesCount}
            forcePage={pageIndex - 1}
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          />
          {/* =========== Table Product Routing ===============*/}
          <div className={`overflow-x-auto`}>
            <TableContainer
              component={Paper}
              className="w-full table-auto overflow-y-hidden space-collapse mt-3.5 text-default"
            >
              <Table aria-label="simple table" sx={Style.borderInherit}>
                <TableHead className="font-medium text-gray-700  text-default bg-gray-100">
                  <TableRow>
                    {column?.map((item, index) => {
                      if (item.visible) {
                        return (
                          <TableCell
                            sx={[Style.MuiTableCellRoot]}
                            key={index}
                            align={`${item.align === 'text-center' ? 'center' : 'inherit'}`}
                            scope="col"
                            className={`${item.visible ? '' : 'hidden'}
                          ${item.sticky}
                           py-2 px-2 border min-w-[120px]  text-left bg-primary ${item.align}`}
                          >
                            {item.columnName}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRows?.map((row, index) => (
                    <TableRow
                      className={`text-default  ${row.orderIndex === 10 ? 'bg-success/100 !text-white hover:bg-green-80' : 'bg-white'
                        } `}
                      key={row.stt}
                    >
                      {/* Số thứ tự */}
                      <TableCell
                        align="center"
                        sx={[Style.MuiTableCellRootTd, Style.sticky1, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {row.stt}
                      </TableCell>
                      {/* Phiên bản routing*/}
                      <TableCell
                        align="center"
                        sx={[Style.MuiTableCellRootTd, Style.sticky2, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {row.routingVersion}
                      </TableCell>
                      {/* Mã thành phẩm/ bán thành phẩm */}
                      <TableCell
                        align="left"
                        sx={[Style.MuiTableCellRootTd, Style.sticky3, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {row.productCode}
                      </TableCell>
                      {/* tên thành phẩm/ bán thành phẩm */}
                      <TableCell
                        sx={[Style.MuiTableCellRootTd, Style.sticky4, row.orderIndex === 10 && Style.hoverColor]}
                        align="left"
                        className="border shadow-xl whitespace-nowrap relative"
                      >
                        <div className="text-truncate whitespace-nowrap xl:truncate max-w-[200px]">
                          {row.productName}
                        </div>
                        <div className="text-tooltip">{row.productName}</div>
                      </TableCell>
                      {/* Thứ tự công đoạn */}
                      <TableCell
                        align="right"
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {row.orderIndex}
                      </TableCell>
                      {/* mã công đoạn */}
                      <TableCell
                        align="left"
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {row.stepCode}
                      </TableCell>
                      {/* tên công đoạn */}
                      <TableCell
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {row.stepName}
                      </TableCell>
                      {/* Hướng dẫn sản xuất*/}
                      <TableCell
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        className=" border text-left relative"
                      >
                        <div className="text-truncate truncate">{row.productionGuide}</div>
                        <div className="text-tooltip">{row.productionGuide}</div>
                      </TableCell>
                      {/* % ước tính hoàn thành*/}
                      <TableCell
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        align="right"
                        className="border whitespace-nowrap text-right"
                      >
                        {row.estimateComplete}
                      </TableCell>
                      {/* thời gian định mức*/}
                      <TableCell
                        align="right"
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap text-right"
                      >
                        {row.ratedTime}
                      </TableCell>
                      {/* khuôn*/}
                      <TableCell
                        align="left"
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {row.molds?.join('/ ')}
                      </TableCell>
                      {/* số sp/tờ */}
                      <TableCell
                        align="right"
                        sx={[Style.MuiTableCellRootTd, row.orderIndex === 10 && Style.hoverColor]}
                        className="border whitespace-nowrap"
                      >
                        {formatNumber(row.productPerPage, 0)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* form modal */}
          <div className={`w-full h-screen fixed bg-modal/70 inset-0 z-[100] ${!open && 'hidden'} `}>
            <div className="fixed min-w-[600px] bg-white top-[20%] left-1/2 -translate-y-1/2 -translate-x-1/2 shadow-xl shadow-modal text-sm rounded border-t-2 border-t-sky-700">
              <div className="flex justify-between px-4">
                <h2 className="text-[20px] text-black py-2">IMPORT FROM EXCEL</h2>
                <button onClick={handleCloseModal}>
                  <MdClose className="text-[20px] text-black/40 hover:text-black" />
                </button>
              </div>
              <form method="POST" className="px-5 pb-2 pt-4 text-default">
                <div className="w-full py-4 sm:flex-row mb-3 sm:items-center grid grid-cols-5 gap-3 border-t-[1px] border-b-[1px] border-gray-200">
                  <label className=" min-w-[150px] font-medium text-gray-700 text-[14px] text-center ">
                    Excel file
                  </label>
                  <input
                    onChange={handleChangeFile}
                    type="file"
                    id="fileExcel"
                    name="fileExcel"
                    className="col-span-4 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-sm focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>

                <div className="w-full sm:flex-row mb-3 sm:items-center grid grid-cols-3 gap-3"></div>
                <div className="flex justify-end mt-3 p-4">
                  <button
                    onClick={ImportExcelProductRouting}
                    type="button"
                    className={`rounded-sm bg-primary hover:bg-primary/90 px-3 py-1 min-w-[80px] text-white`}
                  >
                    Import from Excel
                  </button>
                </div>
              </form>
            </div>
          </div>

          <span className="block mt-3.5 text-sm">
            Đang xem từ {`${tableRows && tableRows.length ? tableRows[0]?.stt : 0}`} đến {`${tableRows && tableRows.length ? tableRows[tableRows.length - 1]?.stt : 0}`} trong tổng số{' '}
            {`${rootStore.productRoutingStore.productRouting.recordsTotal || 0}`} mục
          </span>
        </div>
      </div>
    );
  });
}
